<template>
    <div id="Sales_Settings_Header">
        <div id="FactoryFilterContainer">
            <div class="SalesFilterTitle">工場</div>
            <div class="SalesFilterElement RoundShadowElement">
                <GenericMultiDropdown id="FactoryFilter" :options="FactoryOptions" v-model="SelectedFactories" :-close-on-select=true :-allow-multiple=true label="Test" />
            </div>
        </div>
        <div id="SalesDateFilterFromContainer">
            <div class="SalesFilterTitle">輸入日</div>
            <div class="row mt-1 border" v-show="show.calendar">
                <DatePicker
                    v-model:="SelectedFilterDate"
                    @onSelect="UpdatedFilterDate"
                    :next-prev-icon="true"
                    :last-month="todayDt"
                    :first-month="firstDt"
                    :enable-second-calendar="true"
                />
            </div>
            <!-- <div id='DatePicker' class="SalesFilterElement RoundShadowElement" @click="ShowCalendar()">{{ SelectedFilterDate[0].format("DD MMM, YYYY") }} - {{ SelectedFilterDate[1].format("DD MMM, YYYY") }}</div> -->
            <div id='DatePicker' class="SalesFilterElement RoundShadowElement" @click="ShowCalendar()">{{ SelectedFilterDate[0].format("MMM, YYYY") }} - {{ SelectedFilterDate[1].format("MMM, YYYY") }}</div>
        </div>
        <div style="margin-left: 15px; align-self: center;">
            <div class="SalesFilterTitle">商品スタイル</div>
            <div class="SalesFilterElement RoundShadowElement">
                <div style="display: grid; place-content: center; cursor: pointer;" @click="ToggleProductEntryLength">
                    詳細
                </div>
            </div>
        </div>
        <div style="margin-left: 15px; align-self: center;">
            <div class="SalesFilterTitle">年ショートカット</div>
            <div class="DateShortcuts">
                <ZaikoShortcut :class="{SelJump: entry.year === JumpToYear}" v-for="entry in JumpYears" :key="entry.year" :label="entry.year" @click="OnClickYearShortcut(entry.year)" />
            </div>
        </div>
        <div style="margin-left: 15px; align-self: center;">
            <div class="SalesFilterTitle">月ショートカット</div>
            <div class="DateShortcuts">
                <ZaikoShortcut :class="{SelJump: entry.month === JumpToMonth}" v-for="entry in JumpMonths" :key="entry.month" :label="entry.month" @click="OnClickMonthShortcut(entry.month)" />
            </div>
        </div>
        <div id="SalesSearchContainer">
            <div class="SalesFilterTitle">サーチ</div>
            <div class="SalesFilterElement RoundShadowElement">searchbar</div>
        </div>
    </div>
    <div id="Sales_Data">
        <div id="Sales_Products">
            <div id="ProductsSpace"></div>
            <div id="ProductsContainer">
                <ZaikoProductEntry v-for="entry in DisplayedProducts" :key="entry.styleNumber" :IsDisplaySmallProducts="IsDisplaySmallProducts" :SerialNumber="entry.serialNumber"
                                                             :StyleNumber="entry.productCode" :JAN="entry.JAN" :Factory="GetFactoryName(entry.factory)" :ReleaseDate="FormatImportDate(entry.importDate)"
                                                             :Cost="entry.productionCost" :Price="entry.retailPrice" :WholesalerPrice="entry.wholesalerPrice" :ProductName="entry.productName"
                                                             :OnHover="OnProductHover"/>
                <!-- <div class="SalesProductEntry">
                    <div class="ProductCodesContainer">
                        <div class="ProductCode">hx12345</div>
                        <div class="ProductCode">411-123456P</div>
                        <div class="ProductCode">4532149 023115</div>
                    </div>
                    <div class="ProductInfoContainer RoundShadowElement" :class="{ 'ProductSmall': IsDisplaySmallProducts}">
                        <div v-if="IsDisplaySmallProducts === false" class="ProductFactory">Mirai (Meizu)</div>
                        <div v-if="IsDisplaySmallProducts === false" class="ProductReleaseDate">05/01/2024</div>
                        <div class="ProductName">ゴジラ1999バーニング</div>
                        <div v-if="IsDisplaySmallProducts === false" class="ProductCost">原価：¥14,683</div>
                        <div v-if="IsDisplaySmallProducts === false" class="ProductPrice">上代：¥30,000</div>
                        <div v-if="IsDisplaySmallProducts === false" class="ProductSallerPrice">問屋/値引販売：¥30,000</div>
                    </div>
                    <-- <div style="display: none;" class="ProductInfoContainer ProductSmall RoundShadowElement">
                        <div class="ProductName">ゴジラ1999バーニング</div>
                    </div> --
                </div> -->
            </div>
        </div>
        <div style="flex: 1; width: 1px;">
            <div id="SalesHeadScroll">
                <div id="SalesHead">
                    <!-- <SalesYearContainer v-for="year in JumpYears" :key="year" :Year="year" :DistributorNames="this.Distributors" /> -->
                     <SalesYearContainer :Year="this.JumpToYear" :Month="this.JumpToMonth" :DistributorNames="this.Distributors" />
                </div>
            </div>
            <div id="SalesScroll">
                <div id="Sales_Sales">
                    <div id="SalesContainer">
                        <div id="SalesContainerHelper">
                            <!-- <template v-for="(year, yIndex) in JumpYears" :key="'Year' + yIndex">
                                <template v-for="(month, mIndex) in JumpMonths" :key="'Month' + mIndex">
                                    <ZaikomeisaiSalesDataContainer :Year="year.year" :Month="month.month" :DistributorNames="this.Distributors" />
                                </template>
                            </template> -->
                            <ZaikomeisaiSalesDataContainer :Year="this.JumpToYear" :Month="this.JumpToMonth" :DistributorNames="this.Distributors" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GenericMultiDropdown from '@/components/GenericMultiDropdown.vue';
import moment from "moment";
import DatePicker from "@/components/DatePicker.vue";
import axios from 'axios';
import ZaikoProductEntry from '@/components/ZaikoProductEntry.vue';
import { ShowLoading } from '@/utils/FullScreenLoading';
import ZaikoShortcut from '@/components/ZaikoShortcut.vue';
import SalesYearContainer from '@/components/SalesYearContainer.vue';
import ZaikomeisaiSalesDataContainer from '@/components/ZaikomeisaiSalesDataContainer.vue';
import ZaikoDistributor from '@/classes/ZaikoDistributor';

export default{
    components:
    {
        GenericMultiDropdown,
        DatePicker,
        ZaikoProductEntry,
        ZaikoShortcut,
        SalesYearContainer,
        ZaikomeisaiSalesDataContainer,
    },
    mounted(){
        const hBtn = document.getElementById('H_Btn_Zaiko');
        if (hBtn !== null)
        {
            if (hBtn.classList.contains('HeaderButtonActive') === false)
            {
                hBtn.classList.add('HeaderButtonActive');
            }
        }

        this.GetZaikoData();

        this.ProductsScrollContainer = document.getElementById('ProductsContainer');
        this.ProductsScrollContainer.addEventListener('scroll', this.OnProductsScroll);

        this.SalesScrollContainer = document.getElementById('SalesContainer');
        this.SalesScrollContainer.addEventListener('scroll', this.OnSalesScroll);

        this.SalesHeadScrollContainer = document.getElementById('SalesHeadScroll');
    },
    computed:{
        // disabledDates(){
        //     let dt = [];
        //     let sd = moment('2022-10-22').startOf();
        //     let ed = moment('2022-11-02').startOf();
        //     while (sd.isSameOrBefore(ed)) {
        //         dt.push(sd.clone());
        //         sd.add(1, "days");
        //     }
        //     return dt;
        // }
    },
    methods:{
        OnProductsScroll(event)
        {
             this.SalesScrollContainer.removeEventListener('scroll', this.OnSalesScroll);
             this.SalesScrollContainer.scrollTop = event.target.scrollTop;
             this.SalesScrollContainer.addEventListener('scroll', this.OnSalesScroll);
        },
        OnSalesScroll(event)
        {
            this.ProductsScrollContainer.removeEventListener('scroll', this.OnProductsScroll);
            this.ProductsScrollContainer.scrollTop = event.target.scrollTop;
            this.ProductsScrollContainer.addEventListener('scroll', this.OnProductsScroll);

            this.SalesHeadScrollContainer.scrollLeft = event.target.scrollLeft;
        },
        GetFactoryName(factoryID)
        {
            for (let j = 0; j < this.FactoryOptions.length; j++)
            {
                if (this.FactoryOptions[j].value === factoryID)
                {
                    return this.FactoryOptions[j].label;
                }
            }

            return factoryID;
        },
        FormatImportDate(importDate)
        {
            if (typeof(importDate) !== typeof(Date))
            {
                importDate = new Date(importDate);
            }
            return `${importDate.getFullYear()}年${(importDate.getMonth() + 1).toString().padStart(2,'0')}月`;
        },
        GetSalesDataColor(number, isDisabled = false)
        {
            if (isDisabled === true)
            {
                return number < 0 ? 'CellDisabledRed' : 'CellDisabledGray';
            }
            else
            {
                return number < 0 ? 'CellEnabledRed' : 'CellEnabledBlack';
            }
        },
        async GetZaikoData()
        {
            ShowLoading(true, 'ローディング中');
            this.Products = [];

            let data = {
                SessionToken: this.$GetToken(),
                StartDate: this.SelectedFilterDate[0].format(`YYYY-MM-DD ${process.env.VUE_APP_TIMEZONE_ADD_HOURS}:mm:ss`),
                EndDate: this.SelectedFilterDate[1].format(`YYYY-MM-DD ${process.env.VUE_APP_TIMEZONE_ADD_HOURS}:mm:ss`)
            };

            console.log('Request Zaiko data ',data);

            const zaikoData = await axios.post(`${process.env.VUE_APP_BACKEND_URL}zaikomeisai`, data, {
                headers:
                {
                    'Content-Type': 'application/json'
                }
            })
            .then(async response => {
                ShowLoading(false);
                return response.data;
            })
            .catch(error => {
                ShowLoading(false);
                if (error.response.status != 500)
                {
                    this.$HandleBadRequest(error.response.status, error.response.data);
                }
                console.error('Could not retrieve Zaiko data', error);
            });

            console.log('Received Zaiko Data', zaikoData);

            this.MinYear = new Date().getFullYear();
            this.MaxYear = new Date().getFullYear();

            this.Distributors = [];

            this.Products = zaikoData.zaikoProducts;
            this.DisplayedProducts = [];

            // Move sales and samples data to each product            
            for (let i = 0; i < zaikoData.productZaikoData.length; i++)
            {
                const data = zaikoData.productZaikoData[i];
                let prod = null;
                // Find product
                for (let j = 0; j < this.Products.length; j++)
                {
                    if (this.Products[j].productCode === data.styleNumber)
                    {
                        prod = this.Products[j];

                        if (Object.hasOwn(prod, 'samples') === false)
                        {
                            prod.samples = [];
                        }
                        break;
                    }
                }

                if (prod === null)
                {
                    continue;
                }

                this.MinYear = Math.min(this.MinYear, data.year);
                this.MaxYear = Math.max(this.MaxYear, data.year);

                prod.samples.push(data);
            }

            // const dateShortcutContainer = document.getElementById('DateShortcuts');
            
            // Fill jump year array
            for (let i = this.MinYear; i <= this.MaxYear; i++)
            {
                this.JumpYears.push({
                    year: i,
                });
                // let shortCut = document.createElement('div');
                // shortCut.textContent = i;
                // shortCut.classList.add('SalesFilterElement', 'RoundShadowElement');
                // shortCut.style.textAlign = 'center';
                // shortCut.style.cursor = 'pointer';
                // shortCut.onclick = function() {
                //     this.JumpToYear = i;
                //     this.JumpShortcut();
                // };
                // dateShortcutContainer.append(shortCut);
            }
            // Add jump month (1 - 12)
            for (let i = 1; i <= 12; i++)
            {
                this.JumpMonths.push({
                    month: i,
                });
                // let shortCut = document.createElement('div');
                // shortCut.textContent = i;
                // shortCut.classList.add('SalesFilterElement', 'RoundShadowElement');
                // shortCut.style.textAlign = 'center';
                // shortCut.style.cursor = 'pointer';
                // shortCut.onclick = function() {
                //     this.JumpToMonth = i;
                //     this.JumpShortcut();
                // };
                // dateShortcutContainer.append(shortCut);
            }

            this.JumpToYear = this.JumpYears[this.JumpYears.length - 1].year;
            this.JumpToMonth = this.JumpMonths[new Date().getMonth()].month;

            for (let i = 0; i < zaikoData.productZaikoSales.length; i++)
            {
                const data = zaikoData.productZaikoSales[i];
                let prod = null;
                // Find product
                for (let j = 0; j < this.Products.length; j++)
                {
                    if (this.Products[j].productCode === data.styleNumber)
                    {
                        prod = this.Products[j];

                        if (Object.hasOwn(prod, 'sales') === false)
                        {
                            prod.sales = [];
                        }
                        break;
                    }
                }

                if (prod === null)
                {
                    continue;
                }

                if (this.Distributors.includes(data.hanbaisaki) === false)
                {
                    this.Distributors.push(data.hanbaisaki);
                }

                prod.sales.push(data);
            }

            console.log('collected distributors', this.Distributors);
            
            this.FactoryOptions = [];
            for (let i = 0; i < zaikoData.factories.length; i++)
            {
                this.FactoryOptions.push({ label: zaikoData.factories[i].name, value: zaikoData.factories[i].id });
            }

            // const salesHead = document.getElementById('SalesHead');
            let salesContainer = document.getElementById('SalesContainer');
            let productContainer = document.getElementById('ProductsContainer');
            let spacer = document.getElementById('ProductsSpace');

            // -20 -> padding top+bottom of parent container
            productContainer.style.height = (productContainer.parentElement.offsetHeight - spacer.offsetHeight - 20) + 'px';
            salesContainer.style.height = productContainer.style.height;
            
            salesContainer = document.getElementById('SalesContainerHelper');

            // Build right side layout (no product data yet)

            /*
            for (let i = this.MinYear; i <= this.MaxYear; i++)
            {
                const yearContainer = document.createElement('div');
                yearContainer.classList.add('SalesYearContainer');
                salesHead.append(yearContainer);

                const year = document.createElement('div');
                year.textContent = i;
                year.title = i + '年';
                year.classList.add('SalesYear', 'RoundElement');
                yearContainer.append(year);
                
                const yearMonthContainer = document.createElement('div');
                yearMonthContainer.classList.add('SalesMonthContainer');
                yearContainer.append(yearMonthContainer);

                for (let j = 1; j <= 12; j++)
                {
                    let monthContainer = document.createElement('div');
                    monthContainer.title = `${i}/${j}`;
                    monthContainer.classList.add('SalesMonth');
                    yearMonthContainer.append(monthContainer);

                    const month = document.createElement('div');
                    month.id = `${i}/${j}`;
                    month.textContent = `${j}月`;
                    month.title = `${i}/${j}`;
                    month.classList.add('SalesMonthTitle', 'RoundElement');
                    monthContainer.append(month);

                    const salesDestinationContainer = document.createElement('div');
                    salesDestinationContainer.classList.add('SalesDestinationContainer');
                    monthContainer.append(salesDestinationContainer);

                    let monthSalesDataContainer = document.createElement('div');
                    monthSalesDataContainer.classList.add('MonthSalesData');
                    salesDestinationContainer.append(monthSalesDataContainer);

                    // Month orders + cost
                    let distributorContainer = document.createElement('div');
                    distributorContainer.classList.add('SalesDestination');
                    monthSalesDataContainer.append(distributorContainer);

                    let distributorTitle = document.createElement('div');
                    distributorTitle.classList.add('SalesDestinationTitle');
                    distributorTitle.title = `${i}/${j}`;
                    distributorTitle.textContent = '';
                    distributorContainer.append(distributorTitle);

                    let dataCategories = document.createElement('div');
                    dataCategories.classList.add('SalesCategories');
                    distributorContainer.append(dataCategories);

                    let dataCategory = document.createElement('div');
                    dataCategory.classList.add('SalesCategory');
                    dataCategory.title = `${i}/${j}`;
                    dataCategories.append(dataCategory);
                    
                    let dataTitle = document.createElement('div');
                    dataTitle.classList.add('SalesCategoryTitle', 'RoundElement');
                    dataTitle.textContent = '仕入';
                    dataCategory.append(dataTitle);
                    
                    let dataContainer = document.createElement('div');
                    dataContainer.classList.add('SalesCategory');
                    dataContainer.id = `${i}_${j}_Orders`;
                    salesContainer.append(dataContainer);

                    dataCategory = document.createElement('div');
                    dataCategory.classList.add('SalesCategory');
                    dataCategory.title = `${i}/${j}`;
                    dataCategories.append(dataCategory);

                    dataTitle = document.createElement('div');
                    dataTitle.classList.add('SalesCategoryTitle', 'RoundElement');
                    dataTitle.textContent = '原価計';
                    dataCategory.append(dataTitle);

                    dataContainer = document.createElement('div');
                    dataContainer.classList.add('SalesCategory');
                    dataContainer.id = `${i}_${j}_Cost`;
                    salesContainer.append(dataContainer);

                    for (let k = 0; k < this.Distributors.length; k++)
                    {
                        distributorContainer = document.createElement('div');
                        distributorContainer.classList.add('SalesDestination');
                        monthSalesDataContainer.append(distributorContainer);

                        distributorTitle = document.createElement('div');
                        distributorTitle.classList.add('SalesDestinationTitle');
                        distributorTitle.title = `${i}/${j}`;
                        distributorTitle.textContent = this.Distributors[k];
                        distributorContainer.append(distributorTitle);

                        dataCategories = document.createElement('div');
                        dataCategories.classList.add('SalesCategories');
                        distributorContainer.append(dataCategories);

                        let dataCategory = document.createElement('div');
                        dataCategory.classList.add('SalesCategory');
                        dataCategory.title = `${i}/${j}`;
                        dataCategories.append(dataCategory);

                        let dataTitle = document.createElement('div');
                        dataTitle.classList.add('SalesCategoryTitle', 'RoundElement');
                        dataTitle.textContent = '出荷';
                        dataCategory.append(dataTitle);

                        dataContainer = document.createElement('div');
                        dataContainer.classList.add('SalesCategory');
                        dataContainer.id = `${this.Distributors[k]}_${i}_${j}_Orders`;
                        salesContainer.append(dataContainer);

                        dataCategory = document.createElement('div');
                        dataCategory.classList.add('SalesCategory');
                        dataCategory.title = `${i}/${j}`;
                        dataCategories.append(dataCategory);

                        dataTitle = document.createElement('div');
                        dataTitle.classList.add('SalesCategoryTitle', 'RoundElement');
                        dataTitle.textContent = '売上';
                        dataCategory.append(dataTitle);

                        dataContainer = document.createElement('div');
                        dataContainer.classList.add('SalesCategory');
                        dataContainer.id = `${this.Distributors[k]}_${i}_${j}_Sales`;
                        salesContainer.append(dataContainer);

                        dataCategory = document.createElement('div');
                        dataCategory.classList.add('SalesCategory');
                        dataCategory.title = `${i}/${j}`;
                        dataCategories.append(dataCategory);

                        dataTitle = document.createElement('div');
                        dataTitle.classList.add('SalesCategoryTitle', 'RoundElement');
                        dataTitle.textContent = '利益';
                        dataCategory.append(dataTitle);

                        dataContainer = document.createElement('div');
                        dataContainer.classList.add('SalesCategory');
                        dataContainer.id = `${this.Distributors[k]}_${i}_${j}_Profit`;
                        salesContainer.append(dataContainer);
                    }

                    // Samples and Zaiko
                    let sampleContainer = document.createElement('div');
                    sampleContainer.classList.add('ProductSamplesProcessing');
                    sampleContainer.title = `${i}/${j}`;
                    monthSalesDataContainer.append(sampleContainer);

                    let title = document.createElement('div');
                    title.classList.add('SalesDestinationTitle', 'ProductSamplesProcessingTitle');
                    title.textContent = '見本処理';
                    title.title = `${i}/${j}`;
                    sampleContainer.append(title);

                    dataCategories = document.createElement('div');
                    dataCategories.classList.add('SalesCategories');
                    sampleContainer.append(dataCategories);

                    dataCategory = document.createElement('div');
                    dataCategory.classList.add('SalesCategory');
                    dataCategory.title = `${i}/${j}`;
                    dataCategories.append(dataCategory);

                    dataTitle = document.createElement('div');
                    dataTitle.classList.add('SalesCategoryTitle', 'RoundElement');
                    dataTitle.textContent = '処理数';
                    dataCategory.append(dataTitle);

                    dataContainer = document.createElement('div');
                    dataContainer.classList.add('SalesCategory');
                    dataContainer.id = `${i}_${j}_Samples`;
                    salesContainer.append(dataContainer);

                    dataCategory = document.createElement('div');
                    dataCategory.classList.add('SalesCategory');
                    dataCategory.title = `${i}/${j}`;
                    dataCategories.append(dataCategory);

                    dataTitle = document.createElement('div');
                    dataTitle.classList.add('SalesCategoryTitle', 'RoundElement');
                    dataTitle.textContent = '損';
                    dataCategory.append(dataTitle);

                    dataContainer = document.createElement('div');
                    dataContainer.classList.add('SalesCategory');
                    dataContainer.id = `${i}_${j}_Loss`;
                    salesContainer.append(dataContainer);

                    dataCategory = document.createElement('div');
                    dataCategory.classList.add('SalesCategory');
                    dataCategory.title = `${i}/${j}`;
                    dataCategories.append(dataCategory);

                    dataTitle = document.createElement('div');
                    dataTitle.classList.add('SalesCategoryTitle', 'RoundElement');
                    dataTitle.textContent = '出荷計';
                    dataCategory.append(dataTitle);

                    dataContainer = document.createElement('div');
                    dataContainer.classList.add('SalesCategory');
                    dataContainer.id = `${i}_${j}_TotalShipments`;
                    salesContainer.append(dataContainer);

                    dataCategory = document.createElement('div');
                    dataCategory.classList.add('SalesCategory');
                    dataCategory.title = `${i}/${j}`;
                    dataCategories.append(dataCategory);

                    dataTitle = document.createElement('div');
                    dataTitle.classList.add('SalesCategoryTitle', 'RoundElement');
                    dataTitle.textContent = '末pcs';
                    dataCategory.append(dataTitle);

                    dataContainer = document.createElement('div');
                    dataContainer.classList.add('SalesCategory');
                    dataContainer.id = `${i}_${j}_InventoryQuantity`;
                    salesContainer.append(dataContainer);

                    dataCategory = document.createElement('div');
                    dataCategory.classList.add('SalesCategory');
                    dataCategory.title = `${i}/${j}`;
                    dataCategories.append(dataCategory);

                    dataTitle = document.createElement('div');
                    dataTitle.classList.add('SalesCategoryTitle', 'RoundElement');
                    dataTitle.textContent = '末￥';
                    dataCategory.append(dataTitle);

                    dataContainer = document.createElement('div');
                    dataContainer.classList.add('SalesCategory');
                    dataContainer.id = `${i}_${j}_InventoryValue`;
                    salesContainer.append(dataContainer);
                }
            }
            */

            console.log('sales data done, continue with products');

            this.UpdateDisplayedProducts();

            // for (let i = 0; i < this.DisplayedProducts.length; i++)
            // {
            //     let product = this.DisplayedProducts[i];
            //     console.log('product', product);
                
            //     // Check if filtered
            //     let shipDate = moment(product.importDate);
            //     shipDate.add(9, 'hours');
            //     product.importDate = shipDate;
                
            //     if (shipDate.isBetween(this.SelectedFilterDate[0], this.SelectedFilterDate[1]) === false)
            //     {
            //         continue;
            //     }

            //     if (product.samples === null ||
            //         product.samples === undefined)
            //     {
            //         console.log('Product had no samples data!', product);
            //         continue;
            //     }

            //     if (product.sales === null ||
            //         product.sales === undefined)
            //     {
            //         console.log('Product had no sales data!', product);
            //         continue;
            //     }

            //     if (i === 0)
            //     {
            //         console.log('product info',product);
            //     }

            //     await this.AddProductData(product);

            //     await this.Wait(25);
            // }
        },
        async Wait(time)
        {
            await new Promise(resolve => setTimeout(resolve, time));
        },
        OnProductHover(event)
        {
            // console.log('hover element', event.target);
            // console.log('hover bounding', event.target.getBoundingClientRect());
            if (this.Highlight === null)
            {
                this.Highlight = document.createElement('div');
                document.getElementById('Sales_Data').append(this.Highlight);
                this.Highlight.id = 'SalesHighlight';
            }

            this.Highlight.style.top = event.target.getBoundingClientRect().top + 'px';
        },
        async AddProductData(data, tabIndex)
        {
            let samples = null;

            tabIndex = tabIndex + ((tabIndex - 1) * (this.Distributors.length * 3 + 3));

            for (let i = 0; i < data.samples.length; i++)
            {
                if (data.samples[i].year === this.JumpToYear &&
                    data.samples[i].month === this.JumpToMonth)
                {
                    samples = data.samples[i];
                    break;    
                }
            }

            let ordersCount = samples ? samples.numberOfSamples + samples.inventoryQuantity : 0;
            let totalShipments = samples ? samples.numberOfSamples : 0;

            // Orders: Count all orders for current month + samples + inventory qty
            for (let i = 0; i < data.sales.length; i++)
            {
                const sales = data.sales[i];
                if (sales.year === this.JumpToYear &&
                    sales.month === this.JumpToMonth)
                {
                    ordersCount += data.sales[i].orders;
                    totalShipments += data.sales[i].orders;
                }
            }

            // Orders -> Each distributor's orders + samples + inventory qty
            // Cost -> Orders * product's production cost
            // Loss -> Samples count * product's production cost
            // InventoryValue -> Inventory qty * product's production cost

            const currentYear = this.JumpToYear;
            const currentMonth = this.JumpToMonth;
            // console.log(`Add ${currentYear}/${currentMonth} ${data.productName}`, data);

            let container = document.getElementById(`${this.JumpToYear}_${this.JumpToMonth}_Orders`);
            if (container !== null)
            {
                let dataWrapper = document.createElement('div');
                dataWrapper.classList.add('SalesCategoryData');
                container.append(dataWrapper);

                let dataContainer = document.createElement('div');
                dataContainer.classList.add('SalesData','ProductInfoContainer','CellElement');
                dataWrapper.append(dataContainer);

                let flexDiv = document.createElement('div');
                flexDiv.style.display = 'flex';
                dataContainer.append(flexDiv);

                let value = document.createElement('input');
                value.disabled = true;
                value.classList.add(this.GetSalesDataColor(ordersCount, true));
                value.id = `${data.productCode}_${this.JumpToYear}_${this.JumpToMonth}_Orders`;
                value.value = ordersCount;
                value.tabIndex = -1;
                flexDiv.append(value);
            }

            container = document.getElementById(`${this.JumpToYear}_${this.JumpToMonth}_Cost`);
            if (container !== null)
            {
                let dataWrapper = document.createElement('div');
                dataWrapper.classList.add('SalesCategoryData');
                container.append(dataWrapper);

                let dataContainer = document.createElement('div');
                dataContainer.classList.add('SalesData','ProductInfoContainer','CellElement');
                dataWrapper.append(dataContainer);

                let flexDiv = document.createElement('div');
                flexDiv.style.display = 'flex';
                dataContainer.append(flexDiv);

                let currency = document.createElement('div');
                currency.textContent = '¥';
                currency.style.padding = '0px';
                currency.classList.add('SalesDataCurrency');
                flexDiv.append(currency);

                let value = document.createElement('input');
                value.disabled = true;
                value.tabIndex = -1;
                value.classList.add(this.GetSalesDataColor(data.productionCost * ordersCount, true));
                value.id = `${data.productCode}_${this.JumpToYear}_${this.JumpToMonth}_Cost`;
                value.value = data.productionCost * ordersCount;
                flexDiv.append(value);
            }

            container = document.getElementById(`${this.JumpToYear}_${this.JumpToMonth}_Samples`);
            if (container !== null)
            {
                let dataWrapper = document.createElement('div');
                dataWrapper.classList.add('SalesCategoryData');
                container.append(dataWrapper);

                let dataContainer = document.createElement('div');
                dataContainer.classList.add('SalesData','ProductInfoContainer','CellElement');
                dataWrapper.append(dataContainer);

                let flexDiv = document.createElement('div');
                flexDiv.style.display = 'flex';
                dataContainer.append(flexDiv);

                let value = document.createElement('input');
                value.classList.add(this.GetSalesDataColor(samples ? samples.numberOfSamples : 0));
                value.id = `${data.productCode}_${this.JumpToYear}_${this.JumpToMonth}_Samples`;
                value.value = samples ? samples.numberOfSamples : 0;
                flexDiv.append(value);
                value.tabIndex = tabIndex + (this.Distributors.length * 3);
                value.oninput = function (event) {
                    const oldValue = samples.numberOfSamples;
                    samples.numberOfSamples = parseInt(event.target.value);
                    totalShipments += samples.numberOfSamples - oldValue;
                    ordersCount += samples.numberOfSamples - oldValue;

                    let target = document.getElementById(`${data.productCode}_${currentYear}_${currentMonth}_Loss`);
                    target.value = samples.numberOfSamples * data.productionCost;

                    target = document.getElementById(`${data.productCode}_${currentYear}_${currentMonth}_TotalShipments`);
                    target.value = totalShipments;

                    console.log(`Update ${data.productName}'s orders`);
                    target = document.getElementById(`${data.productCode}_${currentYear}_${currentMonth}_Orders`);
                    target.value = ordersCount;

                    target = document.getElementById(`${data.productCode}_${currentYear}_${currentMonth}_Cost`);
                    target.value = data.productionCost * ordersCount;
                };
            }

            container = document.getElementById(`${this.JumpToYear}_${this.JumpToMonth}_Loss`);
            if (container !== null)
            {
                let dataWrapper = document.createElement('div');
                dataWrapper.classList.add('SalesCategoryData');
                container.append(dataWrapper);

                let dataContainer = document.createElement('div');
                dataContainer.classList.add('SalesData','ProductInfoContainer','CellElement');
                dataWrapper.append(dataContainer);

                let flexDiv = document.createElement('div');
                flexDiv.style.display = 'flex';
                dataContainer.append(flexDiv);

                let currency = document.createElement('div');
                currency.textContent = '¥';
                currency.style.padding = '0px';
                currency.classList.add('SalesDataCurrency');
                flexDiv.append(currency);

                let value = document.createElement('input');
                value.disabled = true;
                value.classList.add(this.GetSalesDataColor(samples ? samples.numberOfSamples * data.productionCost : 0, true));
                value.id = `${data.productCode}_${this.JumpToYear}_${this.JumpToMonth}_Loss`;
                value.value = samples ? samples.numberOfSamples * data.productionCost : 0;
                flexDiv.append(value);
            }

            container = document.getElementById(`${this.JumpToYear}_${this.JumpToMonth}_TotalShipments`);
            if (container !== null)
            {
                let dataWrapper = document.createElement('div');
                dataWrapper.classList.add('SalesCategoryData');
                container.append(dataWrapper);

                let dataContainer = document.createElement('div');
                dataContainer.classList.add('SalesData','ProductInfoContainer','CellElement');
                dataWrapper.append(dataContainer);

                let flexDiv = document.createElement('div');
                flexDiv.style.display = 'flex';
                dataContainer.append(flexDiv);

                let value = document.createElement('input');
                value.disabled = true;
                value.classList.add(this.GetSalesDataColor(totalShipments, true));
                value.id = `${data.productCode}_${this.JumpToYear}_${this.JumpToMonth}_TotalShipments`;
                value.value = totalShipments;
                flexDiv.append(value);
            }

            container = document.getElementById(`${this.JumpToYear}_${this.JumpToMonth}_InventoryQuantity`);
            if (container !== null)
            {
                let dataWrapper = document.createElement('div');
                dataWrapper.classList.add('SalesCategoryData');
                container.append(dataWrapper);

                let dataContainer = document.createElement('div');
                dataContainer.classList.add('SalesData','ProductInfoContainer','CellElement');
                dataWrapper.append(dataContainer);

                let flexDiv = document.createElement('div');
                flexDiv.style.display = 'flex';
                dataContainer.append(flexDiv);

                let value = document.createElement('input');
                value.classList.add(this.GetSalesDataColor(samples ? samples.inventoryQuantity : 0));
                value.id = `${data.productCode}_${this.JumpToYear}_${this.JumpToMonth}_InventoryQuantity`;
                value.value = samples ? samples.inventoryQuantity : 0;
                flexDiv.append(value);
                value.tabIndex = tabIndex + 1 + (this.Distributors.length * 3);
                value.oninput = function (event) {
                    const oldValue = samples.inventoryQuantity;
                    samples.inventoryQuantity = parseInt(event.target.value);
                    ordersCount += samples.inventoryQuantity - oldValue;

                    let target = document.getElementById(`${data.productCode}_${currentYear}_${currentMonth}_InventoryValue`);
                    target.value = samples.inventoryQuantity * -data.productionCost;

                    console.log(`Update ${data.productName}'s orders`);
                    target = document.getElementById(`${data.productCode}_${currentYear}_${currentMonth}_Orders`);
                    target.value = ordersCount;

                    target = document.getElementById(`${data.productCode}_${currentYear}_${currentMonth}_Cost`);
                    target.value = data.productionCost * ordersCount;
                };
            }

            container = document.getElementById(`${this.JumpToYear}_${this.JumpToMonth}_InventoryValue`);
            if (container !== null)
            {
                let dataWrapper = document.createElement('div');
                dataWrapper.classList.add('SalesCategoryData');
                container.append(dataWrapper);

                let dataContainer = document.createElement('div');
                dataContainer.classList.add('SalesData','ProductInfoContainer','CellElement');
                dataWrapper.append(dataContainer);

                let flexDiv = document.createElement('div');
                flexDiv.style.display = 'flex';
                dataContainer.append(flexDiv);

                let currency = document.createElement('div');
                currency.textContent = '¥';
                currency.style.padding = '0px';
                currency.classList.add('SalesDataCurrency');
                flexDiv.append(currency);

                let value = document.createElement('input');
                value.disabled = true;
                value.classList.add(this.GetSalesDataColor(samples ? samples.inventoryQuantity * -data.productionCost : 0, true));
                value.id = `${data.productCode}_${this.JumpToYear}_${this.JumpToMonth}_InventoryValue`;
                value.value = samples ? samples.inventoryQuantity * -data.productionCost : 0;
                flexDiv.append(value);
            }

            for (let k = 0; k < this.Distributors.length; k++)
            {
                let salesData = null;
                for (let l = 0; l < data.sales.length; l++)
                {
                    if (data.sales[l].year === this.JumpToYear &&
                        data.sales[l].month === this.JumpToMonth &&
                        data.sales[l].hanbaisaki === this.Distributors[k])
                    {
                        salesData = data.sales[l];
                        break;
                    }
                }

                if (salesData === null)
                {
                    salesData = new ZaikoDistributor(this.Distributors[k]);
                    data.sales.push(salesData);
                }

                if (data.productCode === '411-600317R')
                {
                    console.log(`debug`, samples);
                }

                container = document.getElementById(`${this.Distributors[k]}_${this.JumpToYear}_${this.JumpToMonth}_Orders`);
                if (container !== null)
                {
                    let dataWrapper = document.createElement('div');
                    dataWrapper.classList.add('SalesCategoryData');
                    container.append(dataWrapper);

                    let dataContainer = document.createElement('div');
                    dataContainer.classList.add('SalesData','ProductInfoContainer','CellElement');
                    dataWrapper.append(dataContainer);

                    let flexDiv = document.createElement('div');
                    flexDiv.style.display = 'flex';
                    dataContainer.append(flexDiv);

                    let value = document.createElement('input');
                    value.classList.add(this.GetSalesDataColor(salesData ? salesData.orders : 0));
                    value.id = `${data.productCode}_${this.Distributors[k]}_${this.JumpToYear}_${this.JumpToMonth}_Orders`;
                    value.value = salesData ? salesData.orders : 0;
                    if (tabIndex===1&&k===0)
                    {
                        console.log(`assign ${this.Distributors[k]}'s orders`, salesData ? salesData.orders : 0);
                    }
                    flexDiv.append(value);
                    value.tabIndex = tabIndex + (k * 3);
                    value.oninput = function (event) {
                        const oldOrders = salesData.orders;
                        salesData.orders = parseInt(event.target.value);
                        ordersCount += salesData.orders - oldOrders;
                        console.log(`Update ${data.productName}'s orders`);
                        let target = document.getElementById(`${data.productCode}_${currentYear}_${currentMonth}_Orders`);
                        target.value = ordersCount;
                        target = document.getElementById(`${data.productCode}_${currentYear}_${currentMonth}_Cost`);
                        target.value = data.productionCost * ordersCount;
                    };
                }

                container = document.getElementById(`${this.Distributors[k]}_${this.JumpToYear}_${this.JumpToMonth}_Sales`);
                if (container !== null)
                {
                    let dataWrapper = document.createElement('div');
                    dataWrapper.classList.add('SalesCategoryData');
                    container.append(dataWrapper);

                    let dataContainer = document.createElement('div');
                    dataContainer.classList.add('SalesData','ProductInfoContainer','CellElement');
                    dataWrapper.append(dataContainer);

                    let flexDiv = document.createElement('div');
                    flexDiv.style.display = 'flex';
                    dataContainer.append(flexDiv);

                    let currency = document.createElement('div');
                    currency.textContent = '¥';
                    currency.style.padding = '0px';
                    currency.classList.add('SalesDataCurrency');
                    flexDiv.append(currency);

                    let value = document.createElement('input');
                    value.classList.add(this.GetSalesDataColor(salesData ? salesData.sales : 0));
                    value.id = `${data.productCode}_${this.Distributors[k]}_${this.JumpToYear}_${this.JumpToMonth}_Sales`;
                    value.value = salesData ? salesData.sales : 0;
                    flexDiv.append(value);
                    value.tabIndex = tabIndex + 1 + (k * 3);
                }

                container = document.getElementById(`${this.Distributors[k]}_${this.JumpToYear}_${this.JumpToMonth}_Profit`);
                if (container !== null)
                {
                    let dataWrapper = document.createElement('div');
                    dataWrapper.classList.add('SalesCategoryData');
                    container.append(dataWrapper);

                    let dataContainer = document.createElement('div');
                    dataContainer.classList.add('SalesData','ProductInfoContainer','CellElement');
                    dataWrapper.append(dataContainer);

                    let flexDiv = document.createElement('div');
                    flexDiv.style.display = 'flex';
                    dataContainer.append(flexDiv);

                    let currency = document.createElement('div');
                    currency.textContent = '¥';
                    currency.style.padding = '0px';
                    currency.classList.add('SalesDataCurrency');
                    flexDiv.append(currency);

                    let value = document.createElement('input');
                    value.classList.add(this.GetSalesDataColor(salesData ? salesData.profit : 0));
                    value.id = `${data.productCode}_${this.Distributors[k]}_${this.JumpToYear}_${this.JumpToMonth}_Profit`;
                    value.value = salesData ? salesData.profit : 0;
                    flexDiv.append(value);
                    value.tabIndex = tabIndex + 2 + (k * 3);
                }
            }

            /*
            for (let y = this.MinYear; y <= this.MaxYear; y++)
            {
                for (let m = 1; m <= 12; m++)
                {
                    let samples = null;

                    for (let i = 0; i < data.samples.length; i++)
                    {
                        if (data.samples[i].year === y &&
                            data.samples[i].month === m)
                        {
                            samples = data.samples[i];
                            break;    
                        }
                    }

                    let ordersCount = samples ? samples.numberOfSamples + samples.inventoryQuantity : 0;
                    let totalShipments = samples ? samples.numberOfSamples : 0;

                    // Orders: Count all orders for current month + samples + inventory qty
                    for (let i = 0; i < data.sales.length; i++)
                    {
                        const sales = data.sales[i];
                        if (sales.year === y &&
                            sales.month === m)
                        {
                            ordersCount += data.sales[i].orders;
                            totalShipments += data.sales[i].orders;
                        }
                    }

                    let container = document.getElementById(`${y}_${m}_Orders`);
                    if (container !== null)
                    {
                        let dataWrapper = document.createElement('div');
                        dataWrapper.classList.add('SalesCategoryData');
                        container.append(dataWrapper);

                        let dataContainer = document.createElement('div');
                        dataContainer.classList.add('SalesData','ProductInfoContainer','CellElement');
                        dataWrapper.append(dataContainer);

                        let flexDiv = document.createElement('div');
                        flexDiv.style.display = 'flex';
                        dataContainer.append(flexDiv);

                        let value = document.createElement('input');
                        value.disabled = true;
                        value.classList.add(this.GetSalesDataColor(ordersCount, true));
                        value.id = `${data.productCode}_${y}_${m}_Orders`;
                        value.value = ordersCount;
                        flexDiv.append(value);
                    }

                    container = document.getElementById(`${y}_${m}_Cost`);
                    if (container !== null)
                    {
                        let dataWrapper = document.createElement('div');
                        dataWrapper.classList.add('SalesCategoryData');
                        container.append(dataWrapper);

                        let dataContainer = document.createElement('div');
                        dataContainer.classList.add('SalesData','ProductInfoContainer','CellElement');
                        dataWrapper.append(dataContainer);

                        let flexDiv = document.createElement('div');
                        flexDiv.style.display = 'flex';
                        dataContainer.append(flexDiv);

                        let currency = document.createElement('div');
                        currency.textContent = '¥';
                        currency.classList.add('SalesDataCurrency');
                        flexDiv.append(currency);

                        let value = document.createElement('input');
                        value.disabled = true;
                        value.classList.add(this.GetSalesDataColor(data.productionCost * ordersCount, true));
                        value.id = `${data.productCode}_${y}_${m}_Cost`;
                        value.value = data.productionCost * ordersCount;
                        flexDiv.append(value);
                    }

                    container = document.getElementById(`${y}_${m}_Samples`);
                    if (container !== null)
                    {
                        let dataWrapper = document.createElement('div');
                        dataWrapper.classList.add('SalesCategoryData');
                        container.append(dataWrapper);

                        let dataContainer = document.createElement('div');
                        dataContainer.classList.add('SalesData','ProductInfoContainer','CellElement');
                        dataWrapper.append(dataContainer);

                        let flexDiv = document.createElement('div');
                        flexDiv.style.display = 'flex';
                        dataContainer.append(flexDiv);

                        let value = document.createElement('input');
                        value.classList.add(this.GetSalesDataColor(samples ? samples.numberOfSamples : 0));
                        value.id = `${data.productCode}_${y}_${m}_Cost`;
                        value.value = samples ? samples.numberOfSamples : 0;
                        flexDiv.append(value);
                    }

                    container = document.getElementById(`${y}_${m}_Loss`);
                    if (container !== null)
                    {
                        let dataWrapper = document.createElement('div');
                        dataWrapper.classList.add('SalesCategoryData');
                        container.append(dataWrapper);

                        let dataContainer = document.createElement('div');
                        dataContainer.classList.add('SalesData','ProductInfoContainer','CellElement');
                        dataWrapper.append(dataContainer);

                        let flexDiv = document.createElement('div');
                        flexDiv.style.display = 'flex';
                        dataContainer.append(flexDiv);

                        let currency = document.createElement('div');
                        currency.textContent = '¥';
                        currency.classList.add('SalesDataCurrency');
                        flexDiv.append(currency);

                        let value = document.createElement('input');
                        value.disabled = true;
                        value.classList.add(this.GetSalesDataColor(samples ? samples.numberOfSamples * data.productionCost : 0, true));
                        value.id = `${data.productCode}_${y}_${m}_Cost`;
                        value.value = samples ? samples.numberOfSamples * data.productionCost : 0;
                        flexDiv.append(value);
                    }

                    container = document.getElementById(`${y}_${m}_TotalShipments`);
                    if (container !== null)
                    {
                        let dataWrapper = document.createElement('div');
                        dataWrapper.classList.add('SalesCategoryData');
                        container.append(dataWrapper);

                        let dataContainer = document.createElement('div');
                        dataContainer.classList.add('SalesData','ProductInfoContainer','CellElement');
                        dataWrapper.append(dataContainer);

                        let flexDiv = document.createElement('div');
                        flexDiv.style.display = 'flex';
                        dataContainer.append(flexDiv);

                        let value = document.createElement('input');
                        value.disabled = true;
                        value.classList.add(this.GetSalesDataColor(totalShipments, true));
                        value.id = `${data.productCode}_${y}_${m}_Cost`;
                        value.value = totalShipments;
                        flexDiv.append(value);
                    }

                    container = document.getElementById(`${y}_${m}_InventoryQuantity`);
                    if (container !== null)
                    {
                        let dataWrapper = document.createElement('div');
                        dataWrapper.classList.add('SalesCategoryData');
                        container.append(dataWrapper);

                        let dataContainer = document.createElement('div');
                        dataContainer.classList.add('SalesData','ProductInfoContainer','CellElement');
                        dataWrapper.append(dataContainer);

                        let flexDiv = document.createElement('div');
                        flexDiv.style.display = 'flex';
                        dataContainer.append(flexDiv);

                        let value = document.createElement('input');
                        value.classList.add(this.GetSalesDataColor(samples ? samples.inventoryQuantity : 0));
                        value.id = `${data.productCode}_${y}_${m}_Cost`;
                        value.value = samples ? samples.inventoryQuantity : 0;
                        flexDiv.append(value);
                    }

                    container = document.getElementById(`${y}_${m}_InventoryValue`);
                    if (container !== null)
                    {
                        let dataWrapper = document.createElement('div');
                        dataWrapper.classList.add('SalesCategoryData');
                        container.append(dataWrapper);

                        let dataContainer = document.createElement('div');
                        dataContainer.classList.add('SalesData','ProductInfoContainer','CellElement');
                        dataWrapper.append(dataContainer);

                        let flexDiv = document.createElement('div');
                        flexDiv.style.display = 'flex';
                        dataContainer.append(flexDiv);

                        let currency = document.createElement('div');
                        currency.textContent = '¥';
                        currency.classList.add('SalesDataCurrency');
                        flexDiv.append(currency);

                        let value = document.createElement('input');
                        value.disabled = true;
                        value.classList.add(this.GetSalesDataColor(samples ? samples.inventoryQuantity * -data.productionCost : 0, true));
                        value.id = `${data.productCode}_${y}_${m}_Cost`;
                        value.value = samples ? samples.inventoryQuantity * -data.productionCost : 0;
                        flexDiv.append(value);
                    }

                    for (let k = 0; k < this.Distributors.length; k++)
                    {
                        let salesData = null;
                        for (let l = 0; l < data.sales.length; l++)
                        {
                            if (data.sales[l].year === y &&
                                data.sales[l].month === m &&
                                data.sales[l].hanbaisaki === this.Distributors[k])
                            {
                                salesData = data.sales[l];
                                break;
                            }
                        }

                        container = document.getElementById(`${this.Distributors[k]}_${y}_${m}_Orders`);
                        if (container !== null)
                        {
                            let dataWrapper = document.createElement('div');
                            dataWrapper.classList.add('SalesCategoryData');
                            container.append(dataWrapper);

                            let dataContainer = document.createElement('div');
                            dataContainer.classList.add('SalesData','ProductInfoContainer','CellElement');
                            dataWrapper.append(dataContainer);

                            let flexDiv = document.createElement('div');
                            flexDiv.style.display = 'flex';
                            dataContainer.append(flexDiv);

                            let value = document.createElement('input');
                            value.classList.add(this.GetSalesDataColor(salesData ? salesData.orders : 0));
                            value.id = `${data.productCode}_${this.Distributors[k]}_${y}_${m}_Orders`;
                            value.value = salesData ? salesData.orders : 0;
                            flexDiv.append(value);
                        }

                        container = document.getElementById(`${this.Distributors[k]}_${y}_${m}_Sales`);
                        if (container !== null)
                        {
                            let dataWrapper = document.createElement('div');
                            dataWrapper.classList.add('SalesCategoryData');
                            container.append(dataWrapper);

                            let dataContainer = document.createElement('div');
                            dataContainer.classList.add('SalesData','ProductInfoContainer','CellElement');
                            dataWrapper.append(dataContainer);

                            let flexDiv = document.createElement('div');
                            flexDiv.style.display = 'flex';
                            dataContainer.append(flexDiv);

                            let currency = document.createElement('div');
                            currency.textContent = '¥';
                            currency.classList.add('SalesDataCurrency');
                            flexDiv.append(currency);

                            let value = document.createElement('input');
                            value.classList.add(this.GetSalesDataColor(salesData ? salesData.sales : 0));
                            value.id = `${data.productCode}_${this.Distributors[k]}_${y}_${m}_Sales`;
                            value.value = salesData ? salesData.sales : 0;
                            flexDiv.append(value);
                        }

                        container = document.getElementById(`${this.Distributors[k]}_${y}_${m}_Profit`);
                        if (container !== null)
                        {
                            let dataWrapper = document.createElement('div');
                            dataWrapper.classList.add('SalesCategoryData');
                            container.append(dataWrapper);

                            let dataContainer = document.createElement('div');
                            dataContainer.classList.add('SalesData','ProductInfoContainer','CellElement');
                            dataWrapper.append(dataContainer);

                            let flexDiv = document.createElement('div');
                            flexDiv.style.display = 'flex';
                            dataContainer.append(flexDiv);

                            let currency = document.createElement('div');
                            currency.textContent = '¥';
                            currency.classList.add('SalesDataCurrency');
                            flexDiv.append(currency);

                            let value = document.createElement('input');
                            value.classList.add(this.GetSalesDataColor(salesData ? salesData.profit : 0));
                            value.id = `${data.productCode}_${this.Distributors[k]}_${y}_${m}_Profit`;
                            value.value = salesData ? salesData.profit : 0;
                            flexDiv.append(value);
                        }
                    }
                }
                
                await this.Wait(25);
            }
            */
        },
        ShowCalendar()
        {
            this.show.calendar = !this.show.calendar;

            if (this.show.calendar === true)
            {
                const closer = document.createElement('div');
                closer.id = 'datecloser';
                closer.style.position = 'absolute';
                closer.style.top = '0px';
                closer.style.left = '0px';
                closer.style.width = '100%';
                closer.style.height = '100%';
                document.body.append(closer);
    
                closer.onclick = ()=>{
                    this.ShowCalendar();
                    closer.remove();
                };
            }
            else
            {
                let closer = document.getElementById('datecloser');
                if (closer !== null)
                {
                    closer.remove();
                }
            }
        },
        UpdatedFilterDate(updatedDate)
        {
            this.SelectedFilterDate = updatedDate;
            console.log('filter date updated', this.SelectedFilterDate);

            let target = document.getElementById('SalesHead');
            if (target !== null)
            {
                target.replaceChildren();
            }
            target = document.getElementById('SalesContainerHelper');
            if (target !== null)
            {
                target.replaceChildren();
            }

            this.GetZaikoData();
            this.ShowCalendar();
        },
        ToggleProductEntryLength(event)
        {
            this.IsDisplaySmallProducts = !this.IsDisplaySmallProducts;
            event.target.textContent = this.IsDisplaySmallProducts ? '簡単' : '詳細';

            // const products = document.getElementsByClassName('SalesProductEntry');
            // for(let i = 0; i < products.length; i++)
            // {
            //     products[i].children[1].style.display = this.IsDisplaySmallProducts ? 'none' : 'flex';
            //     products[i].children[2].style.display = this.IsDisplaySmallProducts ? 'flex' : 'none';
            // }
        },
        OnClickYearShortcut(year)
        {
            if (this.JumpToYear !== year)
            {
                this.JumpToYear = year;
                // this.JumpShortcut();
                this.UpdateDisplayedProducts();
            }
        },
        OnClickMonthShortcut(month)
        {
            if (this.JumpToMonth !== month)
            {
                this.JumpToMonth = month;
                // this.JumpShortcut();
                this.UpdateDisplayedProducts();
            }
        },
        JumpShortcut()
        {
            console.log(`Jump to ${this.JumpToYear} / ${this.JumpToMonth}`);
            const salesContainer = document.getElementById('SalesContainer');
            const targetMonth = document.getElementById(`${this.JumpToYear}/${this.JumpToMonth}`);
            console.log(`first month left: ${targetMonth.getBoundingClientRect().left} SalesContainer left: ${salesContainer.getBoundingClientRect().left} Scroll-X: ${salesContainer.scrollLeft}`);
            salesContainer.scrollTo(targetMonth.getBoundingClientRect().left + salesContainer.scrollLeft - salesContainer.getBoundingClientRect().left, salesContainer.scrollTop);
        },
        async UpdateDisplayedProducts()
        {
            if (this.IsFilteringProducts === false)
            {
                console.log('Start product filter');
                this.IsFilteringProducts = true;

                this.DisplayedProducts = [];
    
                // Remove all created cells
                const cells = document.getElementsByClassName('SalesCategoryData');
                for (let i = 0; i < cells.length; i++)
                {
                    cells[i].remove();
                }
    
                // Filter products that should be displayed
                // based on current selected year, month and
                // if they have data available for the same
                // time frame.
                for (let i = 0; i < this.Products.length; i++)
                {
                    const product = this.Products[i];
    
                    if (product.sales === undefined || product.sales === null)
                    {
                        continue;
                    }
    
                    // Check if has data for current year and month
                    let hasSales = false;
                    let hasSamples = false;
    
                    for (let j = 0; j < product.sales.length; j++)
                    {
                        if (product.sales[j].year === this.JumpToYear &&
                            product.sales[j].month === this.JumpToMonth)
                        {
                            hasSales = true;
                            break;
                        }
                    }
    
                    if (hasSales === false)
                    {
                        for (let j = 0; j < product.samples.length; j++)
                        {
                            if (product.samples[j].year === this.JumpToYear &&
                                product.samples[j].month === this.JumpToMonth)
                            {
                                hasSamples = true;
                                break;
                            }
                        }
                    }
    
                    if (hasSamples === false &&
                        hasSales === false)
                    {
                        continue;
                    }
    
                    // let shipDate = moment(product.importDate);
                    // shipDate.add(9, 'hours');
                    // product.importDate = shipDate;
                    
                    // if (shipDate.isBetween(this.SelectedFilterDate[0], this.SelectedFilterDate[1]) === false)
                    // {
                    //     continue;
                    // }
    
                    if (product.samples === null ||
                        product.samples === undefined)
                    {
                        console.log('Product had no samples data!', product);
                        continue;
                    }
    
                    if (product.sales === null ||
                        product.sales === undefined)
                    {
                        console.log('Product had no sales data!', product);
                        continue;
                    }
    
                    this.DisplayedProducts.push(product);
                }
    
                await this.Wait(25);

                for (let i = 0; i < this.DisplayedProducts.length; i++)
                {
                    let product = this.DisplayedProducts[i];
                    
                    if (i === 0)
                    {
                        console.log('Add product data',product);
                    }
    
                    if (this.RestartProductFilter === false)
                    {
                        await this.AddProductData(product, (i + 1));
                        await this.Wait(25);
                    }
                    else
                    {
                        this.RestartProductFilter = false;
                        this.IsFilteringProducts = false;
                        this.UpdateDisplayedProducts();
                        return;
                    }
                }

                console.log('Product filter complete');
                this.IsFilteringProducts = false;
            }
            else
            {
                console.log('queued product filter restart');
                this.RestartProductFilter = true;
            }
        },
    },
    data(){
        return{
            RestartProductFilter: false,
            IsFilteringProducts: false,
            IsDisplaySmallProducts: false,
            Products: [],
            DisplayedProducts: [],
            show:{
                calendar: false,
            },
            todayDt: moment(),
            firstDt: moment('2019-01-01'),
            SelectedFilterDate:[
                // moment().subtract(7, "days").startOf("day"),
                // moment().endOf("day"),
                // moment().startOf("year"),
                moment().subtract(1, 'month').startOf('month'),
                moment().endOf("year")
            ],
            // disabledFromTo:{
            //     from: moment("2000-01-01"),
            //     to: moment("2019-12-31"),
            // },
            FactoryOptions: [],
            SelectedFactories: [],
            Distributors: [],
            MinYear: 9999,
            MaxYear: 1900,
            ProductsScrollContainer: null,
            SalesScrollContainer: null,
            SalesHeadScrollContainer: null,
            Highlight: null,
            JumpYears: [],
            JumpMonths: [],
            JumpToYear: 2024,
            JumpToMonth: 1,
        }
    }
}
</script>

<style>

.SelJump
{
    background-color: #97f472;
}

.DateShortcuts
{
    display: flex;
}

#SalesHighlight
{
    position: absolute;
    height: 69px;
    width: 100%;
    background-color: #f3f4f3;
    top: 0px;
    z-index: -1;
    transition: 0.2s;
    -moz-transition: 0.2s;
    -webkit-transition: 0.2;
}

#Sales_Settings_Header
{
    display: flex;
    box-shadow: 0px 2px 5px 1px #ccc;
    height: 75px;
    min-height: 75px;
    padding-left: 15px;
    padding-right: 15px;
}

#FactoryFilterContainer
{
    align-self: center;
}

#SeriesFilterContainer
{
    align-self: center;
    margin-left: 10px;
}

#BrandFilterContainer
{
    align-self: center;
    margin-left: 10px;
}

#DatePicker
{
    cursor: pointer;
}

.RoundShadowElement
{
    border: 1px solid #ddd;
    box-shadow: 3px 3px 4px 1px #eaeaea;
    border-radius: 10px;
}

.CellElement
{
    border: 1px solid #ddd;
    border-radius: 0px;
}

.RoundElement
{
    border: 1px solid #ddd;
    border-radius: 10px;
}

#FactoryFilterContainer
{
    width: 250px;
}

#SalesDateFilterFromContainer
{
    margin-left: 15px;
    align-self: center;
}

#SalesDateFilterUntilContainer
{
    margin-left: 15px;
    align-self: center;
}

#SalesSearchContainer
{
    align-self: center;
    margin-left: auto;
}

.SalesFilterTitle
{
    font-size: 0.8rem;
}

.SalesFilterElement
{
    padding: 4px 8px;
    height: 22px;
    align-content: center;
}

#Sales_Data
{
    display: flex;
    flex: 1;
    /* position: relative; */
}

#Sales_Products
{
    padding: 20px 15px;
    padding-bottom: 0px;
    transition: 0.2s;
    -webkit-transition: 0.2s;
    -moz-transition: 0.2s;
    min-width: 676px;
}

#ProductsContainer
{
    overflow-y: auto;
    padding-right: 12px;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

#ProductsContainer::-webkit-scrollbar
{
    display: none;
}

#ProductsSpace
{
    height: 141px;
}

.SalesProductEntry
{

}

.SalesProductEntry div
{
    pointer-events: none;
}

.SalesProductEntry + .SalesProductEntry
{
    margin-top: 20px;
}

.ProductCodesContainer
{
    display: flex;
    padding-left: 10px;
}

.ProductCode
{
    background-color: #e0e0e0;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    text-align: center;
    padding: 0px 10px;
    font-size: 0.9rem;
}

.ProductCode + .ProductCode
{
    margin-left: 8px;
}

.ProductInfoContainer
{
    display: flex;
    padding: 7px 5px;
}

.ProductInfoContainer div
{
    align-content: center;
    align-items: center;
    padding: 3px 10px;
    border-radius: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    text-align: center;
    height: 24px;
}

.ProductInfoContainer div + div
{
    margin-left: 8px;
}

.ProductSmall
{
    width: 330px;
}

.ProductSmall div
{
    width: 100%;
    text-align: left;
    justify-content: unset;
}

.ProductFactory
{
    background-color: #cee9ea;
    width: 112px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ProductReleaseDate
{
    background-color: #e1ceea;
    width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ProductName
{
    background-color: #efefef;
    width: 120px;
    text-align: left !important;
    font-size: 0.7rem;
}

.ProductCost
{
    background-color: #eeb29b;
    flex: 1;
}

.ProductPrice
{
    background-color: #ecdc74;
    flex: 1;
}

.ProductSallerPrice
{
    background-color: #97f472;
    flex: 1;
}

#Sales_Sales
{
    /* 
    flex: 1;
    overflow-x: auto;
    display: flex;
    padding: 20px 15px 20px 10px;
    */
}

#SalesHead
{
    display: flex;
    /*
    overflow-x: auto;
    */
    padding: 20px 0px 0px 0px;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

/* #SalesHead::-webkit-scrollbar
{
    display: none;
} */

#SalesContainer
{
    display: flex;
    overflow-y: auto;
    /* -ms-overflow-style: none;
    scrollbar-width: none; */
}

#SalesContainerHelper
{
    display: flex;
    /* -ms-overflow-style: none;
    scrollbar-width: none; */
}

/* #SalesContainerHelper::-webkit-scrollbar
{
    display: none;
} */

#SalesHeadScroll
{
    overflow-x: auto;
    -ms-overflow-style: none;
    scrollbar-width: none; 
}

#SalesHeadScroll::-webkit-scrollbar
{
    display: none;
}

#SalesScroll
{
    overflow: auto;
}

.SalesYear
{
    height: 32px;
    text-align: center;
    align-content: center;
}

.SalesMonthContainer
{
    display: flex;
}

.SalesMonth
{
    
}

.SalesMonthTitle
{
    background-color: #f9f9f9;
    margin-top: 3px;
    height: 32px;
    text-align: center;
    align-content: center;
}

.SalesDestinationContainer
{
    display: flex;
}

.MonthSalesData
{
    display: flex;
    margin-top: 3px;
}

.SalesCategories
{
    display: flex;
    margin-top: 3px;
}

.SalesCategoryData + .SalesCategoryData
{
    margin-top: 36px;
}

.SalesDestinationTitle
{
    height: 30px;
    align-content: center;
    text-align: center;
    background-color: #eeb29b;
    border-radius: 8px;
    border: 1px solid #ddd;
}

.ProductSamplesProcessingTitle
{
    background-color: #eb7546;
}

.SalesCategory
{
    width: 135px;
}

.SalesCategoryTitle
{
    height: 30px;
    align-content: center;
    text-align: center;
}

.SalesData
{
    margin-top: 17px;
    padding: 7px 5px;
    padding-bottom: 8px;
}

.SalesData input
{
    border: none;
    width: 100%;
    font-size: 1.05rem;
    padding: 0px;
    padding-bottom: 0px;
    text-align: center;
    background-color: rgba(255,255,255,0);
}

.SalesData input:focus
{
    border: none;
    outline: none;
    background: rgb(255, 253, 116);
}

.SalesDataCurrency
{
    display: grid !important;
    text-align: center !important;
    place-content: center !important;
}

.CellDisabledRed
{
    color: rgb(228,134,134);
}

.CellDisabledGray
{
    color: rgb(150,150,150);
}

.CellEnabledRed
{
    color: rgb(198,34,34);
}

.CellEnabledBlack
{
    color: rgb(0,0,0);
}
</style>